// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"725":"4f9d410c","989":"f7b24b1f"}[chunkId] + ".chunk.js";
};